import { render, staticRenderFns } from "./EditWebhookButton.vue?vue&type=template&id=d55f9d78&"
import script from "./EditWebhookButton.vue?vue&type=script&lang=js&"
export * from "./EditWebhookButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports